import {
    faClock,
    faFile,
    faFileExcel,
    faFileImage,
    faFilePdf,
    faFileVideo,
    faFileWord,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import config from '../../../configs/config';
import './ContentButton.css';
import styles from './ContentButton.module.scss';

const ContentButton = (props) => {
    const { content, onClick } = props;

    let symbol = faFile;

    if (content.link.toLowerCase().indexOf(config.basePath) > -1) {
        if (content.link.toLowerCase().indexOf('schedule') > -1) {
            symbol = faClock;
        }
    }
    if (content.link.toLowerCase().indexOf('.pdf') > -1) {
        symbol = faFilePdf;
    } else if (
        content.link.toLowerCase().indexOf('youtube.com') > -1 ||
        content.link.toLowerCase().indexOf('youtube-nocookie.com') > -1 ||
        content.link.toLowerCase().indexOf('vimeo.com') > -1 ||
        content.link.toLowerCase().indexOf('mediadelivery.net') > -1 ||
        content.link.toLowerCase().indexOf('.mp4') > -1 ||
        content.link.toLowerCase().indexOf('.avi') > -1
    ) {
        symbol = faFileVideo;
    } else if (content.link.toLowerCase().indexOf('.doc') > -1) {
        symbol = faFileWord;
    } else if (content.link.toLowerCase().indexOf('.xls') > -1) {
        symbol = faFileExcel;
    } else if (
        content.link.toLowerCase().indexOf('.jpeg') > -1 ||
        content.link.toLowerCase().indexOf('.gif') > -1 ||
        content.link.toLowerCase().indexOf('.jpg') > -1 ||
        content.link.toLowerCase().indexOf('.png') > -1
    ) {
        symbol = faFileImage;
    }

    return (
        <div
            className='card'
            onClick={onClick}
            style={{ border: '2px solid' + props.secondaryColor }}>
            <div className='card-header' style={{ color: props.primaryColor }}>
                <FontAwesomeIcon icon={symbol} className={styles.icon} />
                &nbsp;&nbsp;<React.Fragment>{content.title}</React.Fragment>
            </div>
            <div className='card-body'>
                <p className='card-text'>
                    <React.Fragment>{content.text}</React.Fragment>
                </p>
            </div>
        </div>
    );
};

export default ContentButton;
